function EventSeriesCard({
  eventTitle,
  eventCount,
  nextEventIn,
  numbOfSignups,
  type,
}) {
  return (
    <div className="bg-white shadow-md hover:shadow-xl hover:scale-105 rounded-lg p-6 w-full h-[15rem] flex flex-col justify-evenly">
      <p className="text-3xl font-extrabold">{eventTitle}</p>

      <div className="flex justify-stretch gap-10">
        {type === "form" ? null : (
          <div className="flex flex-col justify-between">
            <p className="font-bold">Events</p>
            <span className="font-extrabold text-3xl text-orange-400">
              {eventCount}
            </span>
          </div>
        )}

        <div>
          <div className="flex flex-col justify-between">
            <p className="font-bold">Signups</p>
            <span className="font-extrabold text-3xl">{numbOfSignups}</span>
          </div>
        </div>
      </div>
      {type === "form" ? null : (
        <p className="text-normal font-bold text-gray-600">
          Next Event in {nextEventIn} days
        </p>
      )}
    </div>
  );
}
export default EventSeriesCard;
